import palette from '../palette';

const MuiButtonGroup = {
  styleOverrides: {
    root: {
      '& .MuiButtonGroup-firstButton.MuiButton-contained.MuiButton-containedPrimary.MuiButtonGroup-grouped':
        {
          borderColor: palette._next.primary.dark,
        },
      '& .MuiButtonGroup-lastButton.MuiButtonGroup-grouped': {
        paddingBottom: 0,
        paddingLeft: 2,
        paddingRight: 2,
        paddingTop: 0,
      },
    },
  },
};

export default MuiButtonGroup;
